import { z } from 'zod';
/** Future use **/
export const OwnerAuth0Schema = z.object({
    csrOrgId: z.string(),
    delegateOrgId: z.string(),
    tplapOrgId: z.string(),
    csrClientId: z.string(),
    delegateClientId: z.string(),
    tplapClientId: z.string(),
});
